import { render, staticRenderFns } from "./VNotificationsBrowse.vue?vue&type=template&id=968f0d38&scoped=true&lang=pug"
import script from "./VNotificationsBrowse.vue?vue&type=script&lang=ts"
export * from "./VNotificationsBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VNotificationsBrowse.vue?vue&type=style&index=0&id=968f0d38&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968f0d38",
  null
  
)

export default component.exports